import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateFrameMachineApi } from "../../services/machine/update.frame.machine.api";

export const useUpdateFrameMachineApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (infoUpdate: any) => updateFrameMachineApi(infoUpdate),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["all-machine-of-store", "all-machine"],
      });
    },
  });
};

